module.exports = __webpack_public_path__ + "static/img/sdsv23gx.15ac829f.png";